<template>
    <div class="com-item img-info-module" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                color: modata.WContent.textColor || '#ffffff'
            }">
                <div class="img-info-module__container">
                    <p class="img-info-module__en" v-if="modata.WContent.enTitle">{{ modata.WContent.enTitle }}</p>
                    <p class="img-info-module__cn" v-if="modata.WContent.cnTitle">{{ modata.WContent.cnTitle }}</p>
                    <div
                        class="img-info-module__desc ql-editor"
                        v-if="modata.WContent.describe"
                        v-html="modata.WContent.describe"
                    ></div>
                    <a
                        class="img-info-module__btn"
                        :href="modata.WContent.btnLink && modata.WContent.btnLink.linkUrl ? modata.WContent.btnLink.linkUrl : 'javascript:void(0)'"
                        target="_self"
                        :style="{
                            borderColor:  modata.WContent.textColor || '#ffffff',
                            color: modata.WContent.textColor || '#ffffff'
                        }"
                        v-if="modata.WContent.btnText"
                        @click.stop="onBtnClick($event)"
                    >
                        <span>{{ modata.WContent.btnText }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "img-info-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'imgInfo',
                    Title: '加入我们',
                    MID: 20,
                    WID: null,
                    ModuleName: 'imgInfoModule',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        onBtnClick(e) {
            const W = this.modata.WContent || {}
            if (!W.btnLink || !W.btnLink.linkUrl) {
                e.preventDefault()
                return
            }
            e.preventDefault()
            this.pageNavigate(W.btnLink.linkUrl)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
p {
    margin: 0;
}
.img-info-module {
    .van-sticky {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center right;
        padding: 6% 0 7%;
    }

    .img-info-module__container {
        width: 90%;
        max-width: 1600px;
        margin: 0 auto;
        animation: puBanner 1s;
    }

    .img-info-module__en {
        line-height: normal;
        font-size: 18px;
        opacity: 0.5;
    }

    .img-info-module__cn {
        line-height: normal;
        font-size: 46px;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        margin-top: 10px;
    }

    .img-info-module__desc {
        margin-top: 20px;
        font-size: 18px;
        line-height: 1.7;
        max-width: 950px;
        ::v-deep p { margin: 0 0 8px; }
    }

    .img-info-module__btn {
        display: inline-block;
        box-sizing: border-box;
        width: 160px;
        margin-top: 3%;
        padding: 12px 0;
        text-align: center;
        background: transparent;
        border: 2px solid currentColor;
        border-radius: 45px;
        font-size: 15px;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.3s;

        span {
            display: block;
            width: 100%;
            position: relative;
            z-index: 1;
        }

        &:hover {
            opacity: 0.85;
        }
    }
}

@keyframes puBanner {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

@media screen and (max-width: 768px) {
    .img-info-module {
        .img-info-module__en{
            font-size: 22px;
        }
        .img-info-module__cn {
            font-size: 32px;
            line-height: 1;
            margin-top: 5px;
        }
        .img-info-module__desc {
            // font-size: 14px;
            line-height: 1.5;
        }
        .img-info-module__btn {
            width: 120px;
            padding: 8px 0;
        }
    }
    
}
</style>
